import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { TOAST_VARIANTS } from 'src/constants/toast.constants'
import { RootState } from 'src/redux/stores/store'

import {
  createApprovalReportExportFailureNotification,
  createApprovalReportExportSuccessNotification,
} from '../toastNotification/NotificationMessages'
import { showToast } from '../toastNotification/toastNotification'

/**
 * Announces bulk exports as they finish.
 *
 * Exports are queued rather than awaited, so the outcome arrives over SignalR
 * long after the dialog that started it has closed. This listener sits at the
 * app root — inside the router, so the success toast can link to the Exports
 * page — and toasts whatever the last completion was.
 */
const BulkExportNotificationListener: React.FC = () => {
  const navigate = useNavigate()
  const lastCompletion = useSelector(
    (state: RootState) => state.ExcelExportedFile.bulkExport.lastCompletion
  )

  useEffect(() => {
    if (!lastCompletion) return

    if (lastCompletion.success) {
      showToast({
        message: createApprovalReportExportSuccessNotification(navigate),
        navigate,
        type: TOAST_VARIANTS.SUCCESS,
      })
      return
    }

    showToast({
      message: createApprovalReportExportFailureNotification(),
      type: TOAST_VARIANTS.ERROR,
    })
  }, [lastCompletion, navigate])

  return null
}

export default BulkExportNotificationListener
